export const home = {
  hero: {
    title: 'Professional Hosting Solutions',
    subtitle: 'High-performance servers, DDoS protection, and 24/7 expert support',
    cta: {
      primary: 'Get Started',
      secondary: 'View Plans'
    }
  },
  features: {
    title: 'Why Choose SynthoHosting',
    description: 'Discover our range of professional hosting solutions',
    ddos: {
      title: 'Advanced DDoS Protection',
      description: 'Protection up to 4 Tbps to keep your services online'
    },
    network: {
      title: 'High-Speed Network',
      description: 'Multiple 10G connections for optimal performance'
    },
    hardware: {
      title: 'Premium Hardware',
      description: 'Latest generation Intel and AMD processors'
    }
  },
  about: {
    title: 'About Us',
    description: 'Professional hosting solutions with guaranteed performance and reliability',
    monitoring: {
      title: '24/7 Monitoring',
      description: 'Continuous infrastructure monitoring'
    },
    support: {
      title: 'Expert Support',
      description: 'Technical team available 24/7'
    },
    network: {
      title: 'Redundant Network',
      description: 'Multiple 10G connections'
    }
  }
};